<template>
  <section class="question-result-container">
    <div v-if="pstatus === '2' || pstatus === '3'">
      <div class="icon">
        <img
          class="icon-img"
          src="@/assets/images/question/normal.png"
          alt=""
        />
      </div>
      <div class="tips">
        <h3>提交成功</h3>
        <p class="desc">{{ tips }}</p>
      </div>
    </div>

    <div v-if="pstatus === '0'">
      <div class="icon">
        <img class="icon-img" src="@/assets/images/question/error.png" alt="" />
      </div>
      <div class="tips">
        <h3>{{ tips }}</h3>
      </div>
    </div>
    <div
      v-if="pstatus !== '0'"
      class="
        go-answer
        c-white
        bg-hll-orange
        f-16
        flex flex-align-center flex-justify-center
      "
      @click="complete"
    >
      完成
    </div>
  </section>
</template>

<script>
import { webcall } from '@hll/driver-js-utils';
import { getAllUrlParams, closeWebView } from '@/tools/other';
import { loadScript } from '@/tools/app';

export default {
  name: 'QuestionResult',
  data() {
    return {
      pstatus: '', // 2: 正常完成 3：提前完成 0：问卷已过期/下架
      tips: '', // 正常完成/提前完成提示文案
    };
  },
  computed: {},
  mounted() {
    webcall({ action: 'setTitle', title: '问卷调查' });
    const params = getAllUrlParams();
    this.pstatus = params.status;
    this.tips = params.tips || '提交成功';
  },
  methods: {
    complete() {
      const urlParams = this.$store.state.app.urlParams;
      this.$hll.toast('谢谢参与');

      setTimeout(() => {
        if (urlParams?.client_type === 'xl_wxa') {
          loadScript(
            'https://van-static.xlcx.cn/xl-static/56822/script/jweixin-1.3.2.js',
            () => {
              if (!window.wx) {
                return;
              }
              window.wx.miniProgram.navigateBack();
            },
          );
        } else {
          closeWebView();
        }
      }, 800);
    },
  },
};
</script>

<style lang="less" scoped>
.question-result-container {
  padding: 0 16px;
  padding-bottom: 44px;
  .icon {
    padding-top: 60px;
    margin-bottom: 24px;
    text-align: center;
    .icon-img {
      width: 80px;
    }
  }
  .tips {
    text-align: center;
    margin-bottom: 40px;
    h3 {
      font-size: 18px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
      margin-bottom: 6px;
    }
    .desc {
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .go-answer {
    height: 44px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    color: #fff;
    background: #ff6600;
    font-size: 16px;
  }
}
</style>
